import { Utility } from "../../api/api-generated";
import { stringIncludesIgnoreCaseIgnoreNullSubstring } from "../../utils/comparisons";
import { UtilitiesFilter, UtilitiesForm } from "./utilitiesTypes";

export const utilityValidator = (item: UtilitiesForm) => {
  if (!item.name || !item.link) return false;
  return true;
};

export const filterUtility = (item: Utility, filters: UtilitiesFilter) => {
  if (
    filters.name &&
    !stringIncludesIgnoreCaseIgnoreNullSubstring(item.name, filters.name)
  )
    return false;
  return true;
};
